import { observable_component } from 'common/util/ComponentDecorator';
import ModalUtil from 'common/util/ModalUtil';

@observable_component
export default class OptForm {
	static classname = 'opt-form';

	constructor($context) {
		this.$context = $context;
		this.requiredFields = ['name', 'email', 'phone'];

		this.validationState = {
			form: 'invalid',
			fields : {
				name: 'invalid',
				phone: 'invalid'
			},
		};

		this.init();
		this.bindEvents();
	}

	get $form() {
		return this.$context.find('.opt-form__form');
	}

	get form_data() {
		return new FormData(this.$form[0]);
	}

	get form_url() {
		return this.$form.attr('action');
	}

	init() {
		var that = this;
		var fields = this.requiredFields;
		$(fields).each(function(i) {
			var fieldName = that.requiredFields[i];
			var fieldInput = $('[name="' + fieldName + '"]');
			var fieldBlock = fieldInput.closest('.formgroup');
			that.checkFieldValidation(fieldName, fieldInput, fieldBlock);
			fieldBlock.removeClass('formgroup--error');
		});

		if( typeof yaCounter26476791 != 'undefined' ) {
			yaCounter26476791.reachGoal('zvonok0');
		}
	}

	bindEvents() {
		var that = this;
		var fields = this.requiredFields;
		$(fields).each(function(i) {
			var fieldName = that.requiredFields[i];
			var fieldInput = $('[name="' + fieldName + '"]');
			var fieldBlock = fieldInput.closest('.formgroup');
			fieldInput.on('input', function() {
				that.checkFieldValidation(fieldName, fieldInput, fieldBlock);
				if (that.validationState.fields[fieldName] === 'invalid') {
					var errorText = fieldName === 'phone' ? 'Введите номер телефона' : 'Заполните поле';
					fieldBlock.append('<div class="formgroup__error">'+errorText+'</div>');
				}
				that.setFormValidation();
			});
		});
		this.$form.on('submit', this.handleSubmitForm);
		this.$context.find('.opt-form__button[type="button"]').on('click', () => {
			this.$form.trigger('submit');
		});
	}

	setFormValidation = () => {
		var that = this;
		var countValidFields = 0;
		$(this.requiredFields).each(function(i) {
			var fieldName = that.requiredFields[i];
			if (that.validationState.fields[fieldName] === 'valid') {
				countValidFields += 1;
			}
		});

		if (countValidFields === this.requiredFields.length) {
			this.validationState.form = 'valid';
			$('.opt-form__button').attr('disabled', false).removeClass('btn--disabled');
		} else {
			this.validationState.form = 'invalid';
			$('.opt-form__button').attr('disabled', true).addClass('btn--disabled');
		}
	};

	checkFieldValidation = (fieldName, fieldInput, fieldBlock) => {
		if (fieldName === 'phone' || fieldName === 'email') {
			var re = fieldName === 'phone'
				? new RegExp('^(\\s*)?(\\+)?([- _():=+]?\\d[- _():=+]?){10,14}(\\s*)?$')
				: new RegExp('^([a-z0-9_-]+\\.)*[a-z0-9_-]+@[a-z0-9_-]+(\\.[a-z0-9_-]+)*\\.[a-z]{2,6}$');
			if (re.test(fieldInput.val())) {
				fieldBlock.removeClass('formgroup--error');
				fieldBlock.find('formgroup__error').remove();
				this.validationState.fields[fieldName] = 'valid';
				this.setFormValidation();
				return true;
			}
			this.validationState.fields[fieldName] = 'invalid';
			fieldBlock.addClass('formgroup--error');
			this.setFormValidation();
			return false;
		} else {
			if (fieldInput.val().length > 0) {
				fieldBlock.removeClass('formgroup--error');
				fieldBlock.find('formgroup__error').remove();
				this.validationState.fields[fieldName] = 'valid';
				this.setFormValidation();
				return true;
			}
			this.validationState.fields[fieldName] = 'invalid';
			fieldBlock.addClass('formgroup--error');
			this.setFormValidation();
			return false;
		}
	};

	handleSubmitForm = e => {
		if ($.cookie('opt_form_test') !== null) {
			return;
		}
		this.errors = [];

		$.ajax({
			url: this.form_url,
			type: 'POST',
			data: this.form_data,
			cache: false,
			contentType: false,
			processData: false
		}).then(this.handleAjaxSuccess);

		e.preventDefault();
		return false;
	};

	handleAjaxSuccess = () => {
		this.$form.remove();
		this.$context.find('.modal__inner').append('<div class="opt-form__thanks">В ближайшее время наш менеджер с Вами свяжется.</div>');
		if( typeof yaCounter26476791 != 'undefined' ) {
			yaCounter26476791.reachGoal('zvonok1');
		}
		window.setTimeout(() => {
			ModalUtil.close()
		}, 10000);
	};
}
